module.exports = __webpack_public_path__ + "static/media/brand3.18c8e513.png";